"use client";

import { Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-2">
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="group relative inline-flex h-9 items-center justify-center rounded-md px-4 py-2 text-sm font-medium text-foreground-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:text-primary-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
                  {item.label}
                  <span className="absolute bottom-1 left-1/2 h-0.5 w-0 bg-primary-light transition-all duration-300 ease-[var(--ease-out-back)] group-hover:w-[calc(100%-2rem)] group-hover:left-4" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-foreground-dark hover:text-primary-light transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md" aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
      </button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 w-full bg-dark-background/95 backdrop-blur-md border-t border-border shadow-medium md:hidden">
          <nav className="flex flex-col p-4 gap-2">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-3 text-sm font-medium text-foreground-dark hover:text-primary-light hover:bg-primary-dark/30 rounded-md transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setFadeIn(true), 100);
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${scrolled ? "bg-gradient-to-r from-secondary-dark/75 via-dark-background/80 to-primary-dark/75 shadow-soft backdrop-blur-sm" : "bg-gradient-to-r from-secondary-dark/65 via-dark-background/70 to-primary-dark/65"} ${fadeIn ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 py-3 flex items-center justify-between relative">
        {}
        <Link to="/" className="flex-shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md">
          <img src="/img/four_dharma_friends_logo.png" alt="Four Dharma Friends" className="h-7" />
        </Link>

        {}
        <MenuProvider menu_id="17" className="flex items-center">
          <HeaderMenuConsumer />
        </MenuProvider>
      </div>
    </header>;
}